const news4 = `## SweatText Official Release!
**2025-09-01**

SweatText is now officially live! This is a beta test, so feedback is key. Trainers can now automate SMS reminders for their clients, improving accountability and engagement. This marks the third release of a core Personal Trainers Club tool, but the biggest tool so far! This solves a very specific problem but along with upcoming tools should provide a wide range of value. There's definitely plenty of improvements to make!
`;


export default news4;